import {CombinedState, combineReducers, Reducer} from 'redux';
import setApiErrorReducer from '../services/appService/setApiError/reducer';
import {SetApiErrorState} from '../services/appService/setApiError/types';
import setAppMountedReducer from '../services/appService/setAppMounted/reducer';
import {SetAppMountedState} from '../services/appService/setAppMounted/types';
import setPathnameReducer from '../services/appService/setPathname/reducer';
import {SetPathnameState} from '../services/appService/setPathname/types';
import setRemoteConfigReducer from '../services/firebaseService/setRemoteConfig/reducer';
import {SetRemoteConfigState} from '../services/firebaseService/setRemoteConfig/types';
import consumeHashReducer from '../services/hashService/consumeHash/reducer';
import {ConsumeHashState} from '../services/hashService/consumeHash/types';
import getHashReducer from '../services/hashService/getHash/reducer';
import {GetHashState} from '../services/hashService/getHash/types';

export interface IStore {
  // APP
  setApiError: SetApiErrorState;
  setAppMounted: SetAppMountedState;
  setPathname: SetPathnameState;
  // FIREBASE
  setRemoteConfig: SetRemoteConfigState;
  // HASH
  consumeHash: ConsumeHashState;
  getHash: GetHashState;
}

export const rootReducer: Reducer<CombinedState<IStore>> = combineReducers({
  // APP
  setApiError: setApiErrorReducer,
  setAppMounted: setAppMountedReducer,
  setPathname: setPathnameReducer,
  // FIREBASE
  setRemoteConfig: setRemoteConfigReducer,
  // HASH
  consumeHash: consumeHashReducer,
  getHash: getHashReducer,
})
